import React from 'react';

const Pay = () => {
    return (
        <div className="mt-5 pt-5">
            <h2 className="text-center">Payment system coming soon.</h2>
        </div>
    );
};

export default Pay;